<template lang="pug">
section(
  class='gallery'
  :class="{ busy: sorting }"
)
  s-page-title(title='Контент сайта')
    template(slot='extension')
      v-btn(@click='onEdit()' color='primary' depressed) Создать
  template(v-if='!isLoading')
    div(v-for='(items, name) in listTreeStruct')
      v-card(class='mb-4')
        v-container(grid-list-xl fluid)
          v-layout(wrap)
            v-flex(xs12)
              div(class='title') {{name}}
            v-flex(xs12)
              tree-list(:items='createTree(items)')
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { createTreeStruct } from '@/utils'
import TreeList from './TreeList'
import emitter from '@/emitter'

export default {
  components: { TreeList },

  data: () => ({
    sorting: false
  }),

  created() {
    this.fetchList()
  },

  mounted() {
    emitter.$on('sitetree.sort', this.onSort)
    emitter.$on('sitetree.edit', this.onEdit)
    emitter.$on('sitetree.create', this.onCreate)
    emitter.$on('sitetree.delete', this.onDelete)
  },

  destroyed() {
    emitter.$off('sitetree.sort', this.onSort)
    emitter.$off('sitetree.edit', this.onEdit)
    emitter.$off('sitetree.create', this.onCreate)
    emitter.$off('sitetree.delete', this.onDelete)
  },

  methods: {
    createTree(data) {
      return createTreeStruct(data)
    },

    onEdit({ id } = {}) {
      this.$router.push({
        name: 'Content.SiteTree.Edit',
        params: { id }
      })
    },

    onCreate({ id }) {
      this.$router.push({
        name: 'Content.SiteTree.Edit',
        params: { id },
        query: { parentId: id }
      })
    },

    async onDelete({ id }) {
      
            if (!(await this.$confirm('Вы уверены?'))) return
      
             try {
               await this.destroy({ id })
             } catch (e) {
               this.$root.showSnack('Ошибка удаления')
             }
      
             this.fetchList()
    },

    async onSort(/*indexes*/) {
      // TODO:
      return

      //       this.sorting = true
      //
      //       try {
      //         await http.post('/gallery/sort-ref', { albums: indexes })
      //       } catch (e) {
      //         this.$root.showSnack('Ошибка сортировки')
      //       }
      //
      //       this.sorting = false
    },

    ...mapActions('content/sitetree', ['fetchList', 'destroy'])
  },

  computed: {
    listTreeStruct() {
      return this.list.reduce((acc, cur) => {
        acc[cur.site_name] || (acc[cur.site_name] = [])
        acc[cur.site_name].push(cur)
        return acc
      }, {})
    },

    ...mapState('content/sitetree', ['total']),
    ...mapGetters('content/sitetree', ['list', 'isLoading'])
  }
}
</script>

<style scoped>
.busy {
  pointer-events: none;
}
.gallery >>> .v-treeview-node__label:first-letter {
  text-transform: uppercase;
}
</style>
